import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useTexts } from "../hooks/useTexts";
import "./Auth.css";

export default function Login() {
    const { getText } = useTexts();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/courses");
        } catch (error: any) {
            setError(getText("login_error", "Ungültige Anmeldedaten. Bitte überprüfe Email und Passwort."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <div className="auth-page-bg"></div>
            <div className="auth-particles">
                {[...Array(4)].map((_, i) => (<div key={i} className="auth-particle"></div>))}
            </div>
            <div className="auth-page-container">
                <div className="auth-page-glass">
                    <div className="auth-page-header">
                        <div className="auth-page-logo">🔐</div>
                        <h1 className="auth-page-title">{getText("login_title", "Willkommen zurück")}</h1>
                        <p className="auth-page-subtitle">{getText("login_subtitle", "Melde dich an, um auf deine Kurse und KI-Tools zuzugreifen")}</p>
                    </div>
                    {error && (<div className="auth-page-message error"><span className="message-icon">⚠️</span><span>{error}</span></div>)}
                    <form onSubmit={handleLogin} className="auth-page-form">
                        <div className="auth-input-group">
                            <div className="auth-input-wrapper">
                                <span className="auth-input-icon">📧</span>
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={getText("login_email_placeholder", "E-Mail Adresse")} className="auth-page-input" required disabled={loading} />
                            </div>
                        </div>
                        <div className="auth-input-group">
                            <div className="auth-input-wrapper">
                                <span className="auth-input-icon">🔒</span>
                                <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder={getText("login_password_placeholder", "Passwort")} className="auth-page-input" required disabled={loading} />
                                <button type="button" className="auth-password-toggle" onClick={() => setShowPassword(!showPassword)}>{showPassword ? "🙈" : "👁️"}</button>
                            </div>
                        </div>
                        <div className="auth-page-links">
                            <Link to="/forgot-password" className="auth-page-link">{getText("login_forgot", "Passwort vergessen?")}</Link>
                        </div>
                        <button type="submit" className={`auth-page-button ${loading ? "loading" : ""}`} disabled={loading || !email || !password}>
                            {loading ? getText("login_loading", "Wird angemeldet...") : getText("login_button", "🚀 Anmelden")}
                        </button>
                        <div className="auth-page-divider">{getText("login_divider", "oder mit")}</div>
                        <div className="auth-page-social">
                            <button type="button" className="auth-social-button google"><span style={{ fontWeight: 'bold', fontSize: '18px' }}>G</span> Google</button>
                            <button type="button" className="auth-social-button github"><span>🐙</span> GitHub</button>
                        </div>
                        <div className="auth-page-links">
                            {getText("login_no_account", "Noch kein Konto?")}{" "}
                            <Link to="/register" className="auth-page-link">{getText("login_register_link", "Jetzt kostenlos registrieren")}</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}